import { Link } from "react-router-dom";

const categories = [
  {
    key: "movie",
    label: "电影解析",
    desc: "剧情剖析 · 幕后解读",
    icon: "ri-film-line",
    to: "/category/movie",
  },
  {
    key: "tv",
    label: "电视剧解析",
    desc: "追剧指南 · 角色分析",
    icon: "ri-tv-2-line",
    to: "/category/tv",
  },
  {
    key: "actors",
    label: "演员资讯",
    desc: "演员档案 · 代表作品",
    icon: "ri-user-star-line",
    to: "/actors",
  },
];

export default function CategoryEntry() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 -mt-16 md:-mt-20 relative z-20">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={c.to}
            className="group bg-background-50 rounded-lg border border-background-200 p-5 md:p-6 flex items-center gap-4 cursor-pointer hover:border-primary-300 transition-colors"
          >
            <div className="w-14 h-14 rounded-lg bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-primary-500 transition-colors">
              <i className={`${c.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
            </div>
            <div className="min-w-0">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-1">{c.label}</h3>
              <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap overflow-hidden text-ellipsis">{c.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}